
import { useScrollLock, useElementSize } from '@vueuse/core'
import WindowStore from '@/store/window'

export const useContextWindow = ($container: Ref<HTMLElement>) => {
  const windowStore = WindowStore()
  const { mouseX, mouseY, windowY, windowHeight, windowWidth } = storeToRefs(windowStore)

  const isLeft = ref(false)
  const isActive = ref(false)

  const setPosition = () => {
    position.value = { x: mouseX.value, y: mouseY.value }
    isActive.value = true
  }

  const position = ref({ x: 0, y: 0 })
  const { width: elementWidth, height: elementHeight } = useElementSize($container)
  let isWindowLocked: null | Ref<boolean> = null

  watch(isActive, (v) => {
    if (isWindowLocked && windowWidth.value <= 1000) isWindowLocked.value = v
  })

  const style = computed(() => {
    if (!$container.value || windowWidth.value < 680 || process.server) return 

    let valueX = position.value.x + 1
    let valueY = position.value.y + 1 - windowY.value

    const maxY = windowHeight.value - elementHeight.value + windowY.value
    const maxX = windowWidth.value - elementWidth.value
  
    isLeft.value = valueX > maxX

    valueY = Math.min(maxY, valueY)

    return {
      transform: `translate3d(${valueX}px, ${valueY}px, 0)`
    }
  })

  onMounted(() => {
    if (process.client) isWindowLocked = useScrollLock(document.body)
  })

  return {
    style,
    setPosition,
    isLeft,
    isActive
  }
}